import api from "../../services/api";


export interface SummaryData {
  estateValue: number;
  totalAssets: number;
  totalLiabilities: number;
  totalInboundCashflow: number;
  totalOutboundCashflow: number;
}

export const getSummary = async (estateId: string): Promise<SummaryData> => {
  const response = await api.get(`/summary/${estateId}`);
  return response.data;
};
